import { Guid, isNotNil, Nillable } from '@web/utils';

export class AdminOwner {
  public constructor(
    private readonly data: {
      id: Guid;
      name?: Nillable<string>;
      email?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): Nillable<string> {
    return this.data.name;
  }

  public get email(): Nillable<string> {
    return this.data.email;
  }

  public get hasDisplayDetails(): boolean {
    return isNotNil(this.name) || isNotNil(this.email);
  }

  public get primaryLabel(): string {
    return this.name ?? this.email ?? this.id;
  }

  public get secondaryLabel(): Nillable<string> {
    if (isNotNil(this.name) && isNotNil(this.email)) {
      return this.email;
    }

    return null;
  }
}
